/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { createPaginationContainer, graphql } from 'react-relay';

import { Button } from './ui/button';
import Reply from './Reply';

class Replies extends React.Component {
  constructor(props) {
    super(props);
    this.loadMore = this.loadMore.bind(this);
    this.state = { foo: 'bar' };
  }

  loadMore() {
    if (!this.props.relay.hasMore() || this.props.relay.isLoading()) {
      return;
    }

    return this.props.relay.loadMore(10, error => {
      return console.error(error);
    });
  }

  render() {
    const hasReplies = this.props.message.replies.edges.length > 0;
    return (
      <div className="mt-3 pt-3 border-t border-gray-200">
        {hasReplies && (
          <h4 className="text-xs font-medium text-gray-600 mb-2 flex items-center">
            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            Replies
          </h4>
        )}
        {this.props.relay.hasMore() ? (
          <div className="mb-2">
            <Button onClick={this.loadMore} variant="ghost" size="sm" className="text-xs h-7">
              Load More Replies
            </Button>
          </div>
        ) : null}
        <div className="space-y-0.5">
          {this.props.message.replies.edges.map(edge => {
            return <Reply reply={edge.node} key={edge.node.id} />;
          })}
        </div>
      </div>
    );
  }
}

Replies = createPaginationContainer(
  Replies,
  {
    message: graphql`
      fragment Replies_message on Message
        @argumentDefinitions(
          count: { type: "Int", defaultValue: 10 }
          cursor: { type: "String" }
        ) {
        id
        replies(last: $count, before: $cursor)
          @connection(key: "Replies_replies") {
          edges {
            node {
              id
              ...Reply_reply
            }
          }
        }
      }
    `,
  },
  {
    direction: 'backward',
    getConnectionFromProps(props) {
      return props.message && props.message.replies;
    },
    // This is also the default implementation of `getFragmentVariables` if it isn't provided.
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
        // userID isn't specified as an @argument for the fragment, but it should be a variable available for the fragment under the query root.
        messageID: props.message.id,
      };
    },
    query: graphql`
      # Pagination query to be fetched upon calling \`loadMore\`.
      # Notice that we re-use our fragment, and the shape of this query matches our fragment spec.
      query RepliesPaginationQuery(
        $count: Int!
        $cursor: String
        $messageID: ID!
      ) {
        message: node(id: $messageID) {
          ...Replies_message @arguments(count: $count, cursor: $cursor)
        }
      }
    `,
  },
);

export default Replies;
